export default "__VITE_ASSET__CNn_Ai8___"